import React from 'react';
import { call, put, select, takeEvery, delay } from 'redux-saga/effects';
import { message, notification, Button } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import user from '../Actions/user';
import gestion from '../Actions/gestionXml';
import certificates from '../Actions/certificates';
import schedule from '../Actions/schedule';
import {
    getUserDataRequest,
    getPreUserDataRequest,
    getUserByEmailRequest,
    getUserById,
    getUserRoleRequest
} from '../Api/User';
import { startLoading, stopLoading } from '../LoadingHelper';
const { types } = user;
const { setUserData, setPreUserData, setUserInfo,setInvoiceData, setRoleData} = user.actions;
const { setDataDownloadFiles, notificationSent } = gestion.actions;
const { setScheduleProperty } = schedule.actions
const { updateCertificatesPagination } = certificates.actions;
const notificationSentProp = state => state.gestionXml.notificationSent;
const taxPayerData = state => state.taxpayer.taxpayerVolume;

export function* getUserData({ query }) {
    const { filter, isFiltered } = query;
    const loadingId = yield call(startLoading, isFiltered? 'taxIdSearchLoading': 'userLoading');
    
    try {
        const response = yield call(getUserDataRequest, query);
        if (response && response.status === 'success') {
            const taxPayer = yield select(taxPayerData);
            const downloadRequest = addMonthlyVolume(response.data.records, taxPayer);
            yield put(setUserData(downloadRequest));
            let taxId = '';
            if (response.data.records.length > 0) {
                taxId = response.data.records[0].taxId
            }

            const isNotificationSent = yield select(notificationSentProp);
            if (!filter && !taxId && !isNotificationSent) {
                yield put(notificationSent(true));
                notification.open({
                    message: 'Aviso',
                    description:
                        'Para poder realizar una solicitud de descarga es necesario cargar sus archivos FIEL desde la pantalla de configuración',
                    icon: <SmileOutlined style={{ color: '#108ee9' }}/>,
                    btn: <a href="./settings"><Button type="primary">Cargar certificados</Button></a>
                });
            }
            
            if(!isFiltered) {
                yield put(updateCertificatesPagination(response.data.metaData));
                yield put(setScheduleProperty({ taxId }));
            }

            yield put(setDataDownloadFiles({ taxId }));
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* getPreUserData({ email }) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(getPreUserDataRequest, email);
        if (response && response.status === 'success') {
            if (response.data !== null)
                yield put(setPreUserData(response.data));
            else {
                message.error('No existe un usuario registrado, intentarlo mas tarde', 5);
                yield delay(2500);
                window.location.href = '/';
            }
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}


export function* getUserInfo({ email }) {
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(getUserByEmailRequest, email);
        if (response && response.status === 'success') {
            if (response.data !== null) {
                yield put(setUserInfo(response.data));
            } else {
                message.error('No se pudo obtener la información del usuario', 5);
            }
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

function addMonthlyVolume(userDataRecords, taxPayer) {
    const downloadRequest = userDataRecords.map(item => {
        let wasFound = taxPayer.find(taxPayerItem => (taxPayerItem.taxId === item.taxId));
        if (!wasFound) {
            wasFound = {};
        }
        const { issuingVolumeMonthly = null, receivingVolumeMonthly = null, createdDate = null, updatedDate = null } = wasFound;
        return {
            ...item,
            issuingVolumeMonthly,
            receivingVolumeMonthly,
            createdDate,
            updatedDate
        };
    });
    return downloadRequest;
}

export function* getRoleData(){
    const loadingId = yield call(startLoading);
    try {
        const response = yield call(getUserRoleRequest);
        if (response && response.status === 'success') {
            if (response.data !== null) {
                yield put(setRoleData(response.data));
            }
        } else {
            message.error(response.message, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* userSaga() {
    yield takeEvery(types.GET_USER_DATA, getUserData);
    yield takeEvery(types.GET_PRE_USER_DATA, getPreUserData);
    yield takeEvery(types.GET_USER_INFO, getUserInfo);
    yield takeEvery(types.GET_ROLE_DATA, getRoleData);
}